/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListDiningTableDto } from '../../models/api-response-list-dining-table-dto';

export interface ListDiningTables$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function listDiningTables(http: HttpClient, rootUrl: string, params: ListDiningTables$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListDiningTableDto>> {
  const rb = new RequestBuilder(rootUrl, listDiningTables.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListDiningTableDto>;
    })
  );
}

listDiningTables.PATH = '/v1/api/dining-tables/list';
